module.exports = __webpack_public_path__ + "img/message_active.ad17df52.svg";